<script setup lang="ts">
//
</script>

<template>
  <!-- Between `lg` and `xl` the sidebar keeps the width it has at `xl` (~300px), so it stays next to the content instead of dropping below it -->
  <div
    class="grid grid-cols-1 gap-5 lg:grid-cols-[minmax(0,1fr)_300px] xl:grid-cols-4 [&>aside]:relative [&>aside]:z-0 [&>aside]:space-y-5 lg:[&>aside>.ReviveAd]:sticky lg:[&>aside>.ReviveAd]:top-32 lg:[&>aside>.ReviveAd]:z-20"
  >
    <slot name="left-sidebar" />
    <div class="xl:col-span-3">
      <slot />
    </div>
    <slot name="right-sidebar" />
  </div>
</template>
